import { createThis2j2avj17cvnv2 as createThis } from '../js/coreRuntime.mjs';
import {
  CoroutineSingletons_UNDECIDED_getInstance3sj7gt8ohsmox as CoroutineSingletons_UNDECIDED_getInstance,
  CoroutineSingletons_RESUMED_getInstance3d1t0ilije73c as CoroutineSingletons_RESUMED_getInstance,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
} from './intrinsics/Intrinsics.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
  Failure21qmuqji4xbjp as Failure,
} from '../Result.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from './Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SafeContinuationClass;
function SafeContinuation() {
  if (SafeContinuationClass === VOID) {
    class $ {
      constructor(delegate, initialResult) {
        return new.target.new_kotlin_coroutines_SafeContinuation_364ty3_k$(delegate, initialResult);
      }
      static new_kotlin_coroutines_SafeContinuation_364ty3_k$(delegate, initialResult) {
        var $this = createThis(this);
        $this.delegate_1 = delegate;
        $this.result_1 = initialResult;
        return $this;
      }
      static new_kotlin_coroutines_SafeContinuation_3yuezq_k$(delegate) {
        return this.new_kotlin_coroutines_SafeContinuation_364ty3_k$(delegate, CoroutineSingletons_UNDECIDED_getInstance());
      }
      get_context_h02k06_k$() {
        return this.delegate_1.get_context_h02k06_k$();
      }
      resumeWith_rk9gbt_k$(result) {
        var cur = this.result_1;
        if (cur === CoroutineSingletons_UNDECIDED_getInstance()) {
          this.result_1 = _Result___get_value__impl__bjfvqg(result);
        } else if (cur === get_COROUTINE_SUSPENDED()) {
          this.result_1 = CoroutineSingletons_RESUMED_getInstance();
          this.delegate_1.resumeWith_rk9gbt_k$(result);
        } else
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Already resumed');
      }
      getOrThrow_23gqzp_k$() {
        if (this.result_1 === CoroutineSingletons_UNDECIDED_getInstance()) {
          this.result_1 = get_COROUTINE_SUSPENDED();
          return get_COROUTINE_SUSPENDED();
        }
        var result = this.result_1;
        var tmp;
        if (result === CoroutineSingletons_RESUMED_getInstance()) {
          tmp = get_COROUTINE_SUSPENDED();
        } else {
          if (result instanceof Failure()) {
            throw result.exception_1;
          } else {
            tmp = result;
          }
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'SafeContinuation', VOID, VOID, [Continuation()]);
    SafeContinuationClass = $;
  }
  return SafeContinuationClass;
}
//region block: exports
export {
  SafeContinuation as SafeContinuation1x0fxyaxo6cwq,
};
//endregion

//# sourceMappingURL=SafeContinuationJs.mjs.map
